import { useCallback, useState } from 'react';

export function useControllableState<V>(controlled: V | undefined, defaultValue: V, onChange?: (value: V) => void) {
  const [uncontrolled, setUncontrolled] = useState(defaultValue);
  const isControlled = controlled !== undefined;
  const value = isControlled ? controlled : uncontrolled;

  const setValue = useCallback(
    (next: V) => {
      if (!isControlled) {
        setUncontrolled(next);
      }
      onChange?.(next);
    },
    [isControlled, onChange],
  );

  return [value, setValue] as const;
}
